import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSubServices, StateStatus } from '@guryou/redux';

const useSubService = ({ serviceId, subServiceId, type }) => {
  const dispatch = useDispatch();
  const { data, status, version, entity } = useSelector(state => state.subServices.all);

  useEffect(() => {
    if (status === StateStatus.NOT_INITIALIZED) {
      dispatch(getSubServices(serviceId));
    }
  }, [dispatch, serviceId, status, type]);

  return { subService: (data || []).find(x => x.id === +subServiceId), status, version, entity };
};

export default useSubService;
